import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const Gapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'gap' && prop !== 'styles' && prop !== 'flexDirection',
})(({ gap = 30, styles, theme, flexDirection = 'column' }) => ({
  display: 'flex',
  flexDirection: flexDirection,
  width: '100%',
  gap: gap,
  justifyContent: 'center',
  ...(typeof styles === 'function' ? styles({ theme }) : styles),
}));

export const figmaLetterSpacing = (fontSizePx, letterSpacingPercent) =>
  `${(fontSizePx * letterSpacingPercent) / 100}px`;

export const getInitials = (name) => {
  if (!name) return '';

  const nameParts = name.trim().split(/\s+/);

  if (nameParts.length >= 2) {
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }

  if (nameParts.length === 1) {
    return nameParts[0][0].toUpperCase();
  }

  return '';
};
